import { render, staticRenderFns } from "./DragDropDemo.vue?vue&type=template&id=26cf7295&"
import script from "./DragDropDemo.vue?vue&type=script&lang=js&"
export * from "./DragDropDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports